import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  mode: 'light',
  sideBar: false
};

const ThemeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleMode: (state) => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
    },
    toggleSideBar: (state) => {
      state.sideBar = !state.sideBar;
    },

  },
});

export const selectMode = (state) => state.theme.mode
export const selectSideBar = (state) => state.theme.sideBar

export const { toggleMode, toggleSideBar } = ThemeSlice.actions;

export default ThemeSlice.reducer;
